import PropTypes from 'prop-types';
import React from 'react';
import CategoryBottomEspot from './Espots/CategoryBottomEspot';
import CategoryHeroEspot from './Espots/CategoryHeroEspot';
import CategoryMarketingCampaignEspot from './Espots/CategoryMarketingCampaignEspot';
import GridCategoryEndEspot from './Espots/GridCategoryEndEspot';

const CategoryPageESpotContent = ({
  hasCatalogMfeEspots, brand, categoryId, children, excludeCategoryHeroEspot,
}) => (
  <div>
    {hasCatalogMfeEspots ? (
      <>
        {
          excludeCategoryHeroEspot
            ? null
            : <CategoryHeroEspot brand={brand} categoryId={categoryId} />
        }
        <CategoryMarketingCampaignEspot brand={brand} categoryId={categoryId} />
      </>
    ) : null}
    {children}
    {hasCatalogMfeEspots ? (
      <>
        <CategoryBottomEspot brand={brand} categoryId={categoryId} />
        <GridCategoryEndEspot brand={brand} categoryId={categoryId} />
      </>
    ) : null}
  </div>
);

CategoryPageESpotContent.propTypes = {
  hasCatalogMfeEspots: PropTypes.bool,
  brand: PropTypes.string.isRequired,
  categoryId: PropTypes.string.isRequired,
  children: PropTypes.node,
  excludeCategoryHeroEspot: PropTypes.bool.isRequired,
};

export default CategoryPageESpotContent;
